import script from "./PuzzleStepPlaceholder.vue?vue&type=script&setup=true&lang=ts"
export * from "./PuzzleStepPlaceholder.vue?vue&type=script&setup=true&lang=ts"

import "./PuzzleStepPlaceholder.vue?vue&type=style&index=0&id=7562f7ef&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7562f7ef"]])

export default __exports__